import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './login/login/login.component';
import { WebleadComponent } from './client/weblead/weblead.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { AuthGuard } from './guard/authG.guard';
import { AccountSettingsComponent } from './pages/account-settings/account-settings.component';
import { UsersComponent } from './pages/users/users.component';
import { RolesComponent } from './pages/roles/roles.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { ConfirmMailComponent } from './login/confirm-mail/confirm-mail.component';
import { Error403Component } from './login/error403/error403.component';
import { Error404Component } from './login/error404/error404.component';
import { LeadcalendarComponent } from './pages/leadcalendar/leadcalendar.component';
import { ErrorDataAccessComponent } from './login/error-data-access/error-data-access.component';

import { SpecodesComponent } from './pages/specodes/specodes.component';
import { WebformComponent } from './pages/webform/webform.component';
import { StatusesComponent } from './pages/statuses/statuses.component';

const routes: Routes = [
  // App routes goes here here
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: '', component: HomeComponent, canActivate: [AuthGuard], pathMatch: 'full' },






      { path: 'account-settings', component: AccountSettingsComponent, canActivate: [AuthGuard] },
      { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
      { path: 'roles', component: RolesComponent, canActivate: [AuthGuard] },

      { path: 'webform', component: WebformComponent, canActivate: [AuthGuard] },

      
      

      { path: 'leadcalendar', component: LeadcalendarComponent, canActivate: [AuthGuard] },
      { path: 'specodes', component: SpecodesComponent, canActivate: [AuthGuard] },
      { path: 'statuses', component: StatusesComponent, canActivate: [AuthGuard] },
    ]
  },

  //no layout routes
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'confirm-mail', component: ConfirmMailComponent },
  { path: 'error403', component: Error403Component },
  { path: 'error404', component: Error404Component },
  { path: 'error-data-access', component: ErrorDataAccessComponent },
  // otherwise redirect to home

  //no layout routes
  { path: 'client/weblead/:cmpn', component: WebleadComponent },
  
  { path: '**', redirectTo: '' }
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
